// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: FuturaLT;
  color: grey;
}
.navigation_nav__9\\+0iq {
  border-bottom: 1px solid grey;
}
.navigation_nav__toggle__3GCDK {
  position: absolute;
  cursor: pointer;
  margin: 0rem 1rem;
  right: 0;
}

.navigation_close__a6mrM,
input[type="checkbox"] {
  display: none;
}
.navigation_hamburger__wME1H {
  margin-top: 0.2rem;
}
.navigation_nav__menu__IhkdH {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  margin: 1rem;
}
li {
  list-style: none;
  display: none;
  margin-right: auto;
  border-bottom-margin-top: 10px;
}
li:first-child {
  margin-right: auto;
  display: block;
  border-bottom: 5px solid white;
}
.navigation_nav__menu__IhkdH a {
  text-decoration: none;
  color: initial;
  font-size: 1.2rem;
}
#navigation_nav__checkbox__piNXc:checked ~ ul.navigation_nav__menu__IhkdH li {
  display: block;
}
#navigation_nav__checkbox__piNXc:checked ~ label.navigation_nav__toggle__3GCDK .navigation_hamburger__wME1H {
  display: none;
}
#navigation_nav__checkbox__piNXc:checked ~ label.navigation_nav__toggle__3GCDK .navigation_close__a6mrM {
  display: block;
}

@media only screen and (min-width: 768px) {
  .navigation_nav__toggle__3GCDK {
    display: none;
  }
  .navigation_nav__menu__IhkdH {
    flex-direction: row;
  }
  .navigation_nav__menu__IhkdH li {
    display: block;
  }
}

.navigation_button__6VcJK {
  background-color: #FF7F50;
  border: none;
  color: white;
  padding: 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}

.navigation_buttons__Tg7Ap{
    list-style: none;
  display: none;
  margin-right: auto;
}

.navigation_hsrc__logo__BoXHY {

  width: auto;
  height: 70px;
  margin-left: 15%;
  }`, "",{"version":3,"sources":["webpack://./src/components/NavigationBar/navigation.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,QAAQ;AACV;;AAEA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;IACI,gBAAgB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB","sourcesContent":["body {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n  font-family: FuturaLT;\r\n  color: grey;\r\n}\r\n.nav {\r\n  border-bottom: 1px solid grey;\r\n}\r\n.nav__toggle {\r\n  position: absolute;\r\n  cursor: pointer;\r\n  margin: 0rem 1rem;\r\n  right: 0;\r\n}\r\n\r\n.close,\r\ninput[type=\"checkbox\"] {\r\n  display: none;\r\n}\r\n.hamburger {\r\n  margin-top: 0.2rem;\r\n}\r\n.nav__menu {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2rem;\r\n  align-items: center;\r\n  margin: 1rem;\r\n}\r\nli {\r\n  list-style: none;\r\n  display: none;\r\n  margin-right: auto;\r\n  border-bottom-margin-top: 10px;\r\n}\r\nli:first-child {\r\n  margin-right: auto;\r\n  display: block;\r\n  border-bottom: 5px solid white;\r\n}\r\n.nav__menu a {\r\n  text-decoration: none;\r\n  color: initial;\r\n  font-size: 1.2rem;\r\n}\r\n#nav__checkbox:checked ~ ul.nav__menu li {\r\n  display: block;\r\n}\r\n#nav__checkbox:checked ~ label.nav__toggle .hamburger {\r\n  display: none;\r\n}\r\n#nav__checkbox:checked ~ label.nav__toggle .close {\r\n  display: block;\r\n}\r\n\r\n@media only screen and (min-width: 768px) {\r\n  .nav__toggle {\r\n    display: none;\r\n  }\r\n  .nav__menu {\r\n    flex-direction: row;\r\n  }\r\n  .nav__menu li {\r\n    display: block;\r\n  }\r\n}\r\n\r\n.button {\r\n  background-color: #FF7F50;\r\n  border: none;\r\n  color: white;\r\n  padding: 20px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n  margin: 4px 2px;\r\n  cursor: pointer;\r\n}\r\n\r\n.buttons{\r\n    list-style: none;\r\n  display: none;\r\n  margin-right: auto;\r\n}\r\n\r\n.hsrc__logo {\r\n\r\n  width: auto;\r\n  height: 70px;\r\n  margin-left: 15%;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nav": `navigation_nav__9+0iq`,
	"nav__toggle": `navigation_nav__toggle__3GCDK`,
	"close": `navigation_close__a6mrM`,
	"hamburger": `navigation_hamburger__wME1H`,
	"nav__menu": `navigation_nav__menu__IhkdH`,
	"nav__checkbox": `navigation_nav__checkbox__piNXc`,
	"button": `navigation_button__6VcJK`,
	"buttons": `navigation_buttons__Tg7Ap`,
	"hsrc__logo": `navigation_hsrc__logo__BoXHY`
};
export default ___CSS_LOADER_EXPORT___;
